import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers, mediaQuery } = baseVariables;

export const Wrapper = styled.div`
  position: relative;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
  padding-block: ${spacers?.spacers?.[5] ?? '2rem'};

  ${mediaQuery.md} {
    padding-block: calc(${spacers?.spacers?.[5] ?? '2rem'} + ${spacers?.spacers?.[3] ?? '1rem'});
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${spacers?.spacers?.[3] ?? '1rem'};
  width :100%;
  margin-inline: auto;
  max-width: 1200px;
  padding-inline: calc(${spacers?.spacers?.[5] ?? '2rem'} + ${spacers?.spacers?.[4] ?? '1.5rem'});

  ${mediaQuery.md} {
    padding-inline: calc(${spacers?.spacers?.[5] ?? '2rem'} + ${spacers?.spacers?.[5] ?? '2rem'});
  }
`;

export const TextWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const DismissWrapper = styled.div`
  position: absolute;
  inset-block-start: ${spacers?.spacers?.[3] ?? '1rem'};
  inset-inline-end: ${spacers?.spacers?.[3] ?? '1rem'};

  ${mediaQuery.md} {
    inset-block-start: ${spacers?.spacers?.[4] ?? '1.5rem'};
    inset-inline-end: ${spacers?.spacers?.[4] ?? '1.5rem'};
  }
`;
